import type { RouteLocationNormalized } from 'vue-router'

import { ROUTE_RITUAL } from '~/contexts/ritual/router/routes'

import { Navigation404Error, NavigationRedirectError } from '~/router/errors'
import { hasParamsChanged } from '~/router/utils/has-params-changed'

import { getRitual } from '~/entities/content/ritual/api/rituals'

import type { SUBJECT_6W_URI } from '~/features-shared/libs/interfaces/entity'

import { verifyFeatureAvailability } from '~/features-generic/config-manager/composables/feature-manager'

import type { NavigationGuard } from '~/typings/vue-router'

function checkRitualExist(uri: SUBJECT_6W_URI) {
  return getRitual(uri)
    .catch(() => {
      throw new Navigation404Error('This ritual does not exist', { name: ROUTE_RITUAL.HOME })
    })
}

export const navigationGuardRitual: NavigationGuard<ROUTE_RITUAL> = (to, from, next) => {
  return Promise.resolve()
    .then(async () => {
      return verifyFeatureAvailability('rituals.enabled')
        .then((result) => {
          if (!result)
            throw new Navigation404Error('This page does not exist')
        })
    })
    .then(() => {
      if (hasParamsChanged(to, from, 'thread_id')) {
        const _to = to as RouteLocationNormalized<ROUTE_RITUAL.URI_HOME>
        return checkRitualExist(_to.params.thread_id!)
      }
    })
    .then(() => next())
    .catch((error) => {
      if (error instanceof NavigationRedirectError)
        return next(error.to)

      next(error)
    })
}
